import React, {useContext, useEffect, useRef, useState} from "react";

import ItemOptionsModal from "../../components/item-options-modal/ItemOptionModal.jsx";
import ItemCard from "../../components/item-card/ItemCardController.jsx";
import {GlobalContext} from "../../globals/globalContext.jsx";
import {currencyFormat} from "../../util/i18n.js";
import {del, post, put} from "../../util/fetch.js";
import {useIntl} from "react-intl";

export default function CartItem(props) {
  const intl = useIntl();
  const {
    cartItemListRef,
    delivery,
    editable,
    isItemOpen,
    index,
    toggleEditVisible,
    handleIncrementClick,
    handleDecrementClick,
    handleDropdownQuantityChange,
    handleRemoveClick,
    isLoading,
    handleClick,
    openedId,
    changeId,
    setChangeId,
  } = props;
  const {
    id,
    deliver_listing,
    stock_event,
    article_display_name,
    article_name_and_qualities,
    contents_amount_display,
    deposit_price,
    producer_name,
    is_contained,
    display_in_cart,
    hide_sale_price_in_cart,
    sale_price_pro_sale_unit,
    sale_price_pro_bu,
    show_stk_unit_in_frontend,
  } = props.item;
  const { fetchDelivery, onFavouriteAddRemove, setRuleCount } =
    useContext(GlobalContext);

  const [rule, setRule] = useState(props.item.rule);

  const itemRef = useRef(null);
  const cardRef = useRef(null);
  const prevValues = useRef(changeId);
  const { logoSmallUrl, colorSecondary } = useContext(GlobalContext);

  const listing = deliver_listing || props.item; // when it comes straight from the catalog, its a deliver_listing. if it was in the cart already then its a deliver_order which has a FK to deliver_listing

  const incl_deposit = deposit_price
    ? "+" +
      currencyFormat(deposit_price) +
      "€ " +
      intl.formatMessage({ id: "deposit_lc" })
    : null;

  const sales_unit_display = stock_event
    ? stock_event.sales_unit_display
    : listing.sales_unit_display;
  const product_details = listing.article.nutrition_product_details;
  const sales_package_weight = stock_event
    ? stock_event.sales_package_weight
    : listing.sales_package_weight;
  const { product_unit, base_unit } = stock_event
    ? stock_event.sku
    : listing.article.sku;
  const { num_portions_in_cart, has_different_amount_in_cart, is_packed } =
    props.item;
  const article_name = article_display_name
    ? article_display_name
    : article_name_and_qualities;
  const article_name_without_qualities = deliver_listing
    ? deliver_listing.article.name
    : props.item.article.name;
  const article_quality = deliver_listing
    ? deliver_listing.article._qualities
    : props.item.article._qualities;
  const producer = stock_event ? producer_name : listing.article.producer;
  const producer_display = producer ? producer : "";
  const unit_to_render = base_unit
    ? base_unit.measure
    : product_unit.base_unit.measure;

  const base_price = product_unit
    ? currencyFormat(sale_price_pro_bu) + "€/" + product_unit.base_unit.name
    : currencyFormat(sale_price_pro_bu) + "€/" + base_unit.name;
  const base_price_display = hide_sale_price_in_cart ? "" : base_price;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [shouldDisplayToggle, setShouldDisplayToggle] = useState(false);
  const [hasSyncedFromModal, setHasSyncedFromModal] = useState(false);
  const [syncWithRule, setSyncWithRule] = useState(false);

  const stk = deliver_listing
    ? deliver_listing.show_stk_unit_in_frontend
      ? intl.formatMessage({ id: "pieceCa" })
      : ""
    : show_stk_unit_in_frontend
    ? intl.formatMessage({ id: "pieceCa" })
    : "";

  const nahrwerte_string = ["piece", "weight"].includes(unit_to_render)
    ? intl.formatMessage({ id: "nutritionG" })
    : intl.formatMessage({ id: "nutritionML" });

  const isPacked = is_packed;

  const isAtLeastOneNutrition = product_details
    ? Object.entries(product_details).map(([key, value]) => {
        if (
          key !== "description" &&
          key !== "producer_info" &&
          key !== "product_info" &&
          key !== "storage_info" &&
          key !== "usage_info" &&
          key !== "description" &&
          value
        ) {
          return true;
        }
        return false;
      })
    : false;

  const customToggleEditVisible = (e) => {
    props.handleClick(null);
    if (!e.target.className.includes("qts")) {
      toggleEditVisible(id);
    }
  };

  function handleDestCollapsible(detailType) {
    const detailId = detailType + listing.id;
    if (detailId === props.openedId) {
      props.handleClick(null);
    } else {
      props.handleClick(detailId);
    }
  }

  const handleNutritionalCollapsible = () => {
    if (listing.id === openedId) {
      handleClick("close" + listing.id);
    } else {
      handleClick(listing.id);
    }
  };

  function handleConfirmModal(
    ruleProductData,
    isAdjustingForFutureDate,
    syncWithCart = undefined,
  ) {
    const { item } = props;
    const patch = {
      id: null,
      deliver_listing: item.deliver_listing,
      action: ruleProductData.amount,
    };

    const updateStateAndCloseModal = () => {
      props.onChange(patch);
      setIsModalOpen(false);
    };

    const handleError = (error) => {
      console.error(error);
    };

    const processRule = (updateAfterProcessing = false) => {
      const ruleId = ruleProductData["rule_id"];
      const isOnce = ruleProductData.periodicity === "ONCE";
      const apiUrl = "/api/rule-product/" + (ruleId ? ruleId + "/" : "");

      if (isOnce) {
        ruleId
          ? del(apiUrl).then((ruleDetail) => {
              if (item.rule && item.rule.is_temporary) {
                setRuleCount((prevCount) => prevCount - 1);
              }
              setRule(ruleDetail);
              updateStateAndCloseModal();
            }, handleError)
          : updateStateAndCloseModal();
      } else {
        const isTemporary = ruleProductData.is_temporary;
        delete ruleProductData.amount;

        const stableRuleHasToBeSyncedWithCart =
          ruleId && !isTemporary && syncWithCart;

        if (syncWithCart !== undefined) {
          // if undefined, it means the user has not interacted with the toggle
          if (isAdjustingForFutureDate) {
            ruleProductData.amount = ruleProductData.totalAmount;
          } else {
            delete ruleProductData.amount;
          }

          ruleProductData.temporary_amount = ruleProductData.totalAmount;
        }

        delete ruleProductData.totalAmount;
        delete ruleProductData.is_temporary;

        const requestMethod = ruleId ? put : post;
        const requestPromise = requestMethod(apiUrl, { body: ruleProductData });

        if (
          !ruleId &&
          ruleProductData.mode === "subscribe" &&
          isTemporary &&
          ruleProductData.temporary_amount >= 1
        ) {
          setRuleCount((prevCount) => prevCount + 1);
        }
        if (updateAfterProcessing || stableRuleHasToBeSyncedWithCart) {
          requestPromise.then((ruleDetail) => {
            setRule(ruleDetail);
            setHasSyncedFromModal(true);
            updateStateAndCloseModal();
          }, handleError);
        } else {
          requestPromise.then((ruleDetail) => {
            setRule(ruleDetail);
            fetchDelivery();
            setIsModalOpen(false);
          }, handleError);
        }
      }
    };

    processRule(ruleProductData.is_temporary);
  }

  function handleOpenModal() {
    setIsModalOpen(true);
  }

  useEffect(() => {
    setRule(props.item.rule);
  }, [props.item.rule]);

  useEffect(() => {
    if (props.item?.rule) {
      const ruleAmount = props.item.rule.amount;
      const ruleTemporaryAmount = props.item.rule.temporary_amount;

      const ruleHasTemporaryChanges = ruleAmount !== ruleTemporaryAmount;
      const ruleDiffersFromCart = num_portions_in_cart !== ruleTemporaryAmount;
      const ruleTemporaryAmountIsSameAsCart = !ruleDiffersFromCart;

      const _shouldDisplayToggle =
        !props.item.rule.is_temporary && (
          (ruleDiffersFromCart && ruleHasTemporaryChanges) ||
          has_different_amount_in_cart
        );

      setShouldDisplayToggle(_shouldDisplayToggle);
      setSyncWithRule(
        _shouldDisplayToggle &&
          ruleHasTemporaryChanges &&
          ruleTemporaryAmountIsSameAsCart,
      );
    }
  }, [num_portions_in_cart, props.item?.rule]);

  useEffect(() => {
    props.item.syncWithRule = syncWithRule;
  }, [syncWithRule]);

  return (
    <>
      {isModalOpen && (
        <ItemOptionsModal
          deliver_order={props.item}
          deliver_listing={props.item.deliver_listing}
          delivery={delivery}
          rule={rule}
          onClose={() => setIsModalOpen(false)}
          onConfirm={handleConfirmModal}
          quantityInCart={num_portions_in_cart}
        />
      )}
      <ItemCard
        position={"cart"}
        isListCard={true}
        id={listing.id}
        subscriptionId={delivery.subscription.id}
        isFavourite={props.isFavourite}
        editable={editable && !isPacked}
        isItemOpen={isItemOpen}
        product_details={product_details}
        product_image={listing?.article?.image}
        article_quality={article_quality}
        article_name={article_name}
        article_name_without_qualities={article_name_without_qualities}
        contents_amount_display={contents_amount_display}
        is_contained={is_contained}
        display_in_cart={display_in_cart}
        sale_price_pro_bu={sale_price_pro_bu}
        hide_sale_price_in_cart={hide_sale_price_in_cart}
        sale_price_pro_sale_unit={sale_price_pro_sale_unit}
        stk={stk}
        incl_deposit={incl_deposit}
        sales_unit_display={sales_unit_display}
        sales_package_weight={sales_package_weight}
        num_portions_in_cart={num_portions_in_cart}
        base_price_display={base_price_display}
        producer_display={producer_display}
        handleDecrementClick={handleDecrementClick}
        handleDropdownQuantityChange={handleDropdownQuantityChange}
        handleRemoveClick={handleRemoveClick}
        isLoading={isLoading}
        handleIncrementClick={handleIncrementClick}
        handleNutritionalCollapsible={handleNutritionalCollapsible}
        handleDestCollapsible={handleDestCollapsible}
        customToggleEditVisible={customToggleEditVisible}
        listing={deliver_listing}
        openedId={openedId}
        nahrwerte_string={nahrwerte_string}
        isAtLeastOneNutrition={isAtLeastOneNutrition}
        logoSmallUrl={logoSmallUrl}
        colorSecondary={colorSecondary}
        itemRef={itemRef}
        cardRef={cardRef}
        listRef={cartItemListRef}
        rule={props.item.rule}
        handleOpenModal={handleOpenModal}
        onFavouriteAddRemove={onFavouriteAddRemove}
        index={index}
        shouldDisplayToggle={shouldDisplayToggle}
        syncWithRule={syncWithRule}
        setSyncWithRule={setSyncWithRule}
        setRule={setRule}
      />
    </>
  );
}
